import React, { Component } from 'react'
import {
  getProjects,
} from '../../store/ducks/humanResources'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link, Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Table,
} from 'reactstrap'
import moment from 'moment'
import Select from '../../components/Template/Input/Select'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { selectValues } from '../../utils/fc'

class FinishExpedient extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAllProjects: false,
    }
  }

  render() {
    const { showAllProjects } = this.state;
    const { projects } = this.props;
    const displayedProjects = projects ? projects.filter(p => showAllProjects || p.proj_situacao === 3) : [];

    return (
      <Card>
        <CardBody>
          <Row className="d-flex justify-content-between align-items-center mb-4">
            <Col>
              <h4 className="card-title m-0">Meus Projetos</h4>
            </Col>
            <Col className="text-end">
              <Button size="sm" color="primary" onClick={() => this.setState({showAllProjects: !showAllProjects})}>
                {showAllProjects ? 'Esconder Concluídos' : 'Exibir todos'}
              </Button>
            </Col>
          </Row>
            {displayedProjects.length > 0 &&
              displayedProjects.map(p => (
                <>
                  <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${p.proj_id}`}
                  style={{ color: p.proj_situacao === 3 ? '' : '#9ca3af' }}
                >
                  {p.proj_nome}
                  </a>
                  <br />
                </>
              ))
              }
        </CardBody>
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  humanResources: state.humanResources,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getProjects,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(FinishExpedient)
